import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const CONVERSATIONS = () => `${API_BASE}/api/v3/messages/conversations/`
export const CONVERSATION = ({conversationId, ...params}) => URI(`${API_BASE}/api/v3/messages/conversations/${conversationId}/`).addSearch(params)
export const MESSAGES = ({ conversationId }) => `${API_BASE}/api/v3/messages/conversations/${conversationId}/messages/`
